module.exports = __webpack_public_path__ + "static/media/mbis_img_4.b47912a7.png";